import { Component } from '@angular/core';
import { GoBackComponent } from 'shared/components/go-back/go-back.component';
import { TranslateModule } from '@ngx-translate/core';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';

@Component({
  selector: 'app-making-deposit',
  templateUrl: './making-deposit.component.html',
  styleUrl: './making-deposit.component.scss',
  standalone: true,
  imports: [GoBackComponent, TranslateModule, KorviuButtonComponent]
})
export class MakingDepositComponent {
  makingDeposit: any = {
    title: 'okeeyCash.makingDeposit.title',
    addFund: 'okeeyCash.makingDeposit.addFund',
    link: 'https://usa.okeeycash.com/assets/documents/DDAform.pdf',
    extensiveOption: 'okeeyCash.makingDeposit.extensiveOption',
    reloadingOption: 'okeeyCash.makingDeposit.reloadingOption',
    charge: 'okeeyCash.makingDeposit.charge',
    freeExperience: 'okeeyCash.makingDeposit.freeExperience',
    settlingUp: 'okeeyCash.makingDeposit.settlingUp',
    directDeposit: 'okeeyCash.makingDeposit.directDeposit',
    yourCard: 'okeeyCash.makingDeposit.yourCard',
    illustration: 'assets/img/my-okeey-cash/making-deposit/illustration.svg',
    illustrationMobile: 'assets/img/my-okeey-cash/making-deposit/illustration-mobile.svg',
    findLocation: 'okeeyCash.makingDeposit.findLocation'
  };

  public openLink(link): void {
    window.open(link, '_blank');
  }

  public findLocation(): void {
    window.open('https://secure.attheregister.com/locations', '_blank');
  }
}
